const SITE = "https://www.awasource.com/";

const slug = (name) =>
  String(name || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60);

// The site records these on arrival and attaches them to any signup or
// enquiry, so leads can be traced to the page and the partner whose
// candidate clicked.
export const poweredByUrl = (page, partnerName) => {
  const url = new URL(SITE);
  url.searchParams.set("utm_source", "partner_assessment");
  url.searchParams.set("utm_medium", "powered_by");
  url.searchParams.set("utm_campaign", page);
  const partner = slug(partnerName);
  if (partner) url.searchParams.set("utm_content", partner);
  return url.toString();
};
